<template>
    <div id="content">
      <popup
          v-show="hasPopup"
          :popup-type="getPopupType"
          :popup-action="getPopupAction"
          @popup-action="executePopupAction">
		</popup>
        <div class="inner">
            <add-button v-if="$_createActionAllowed" :title="'Přidat uživatele' | translate" route-name="userNew"></add-button>
            <h1 v-translate>Uživatelé</h1>
        </div>

        <div class="inner_white">
            <div class="filter">
                <div class="field_left">
                    <search-input input-class="search" v-model="formFields.search"></search-input>
                </div>
                <div class="field_right">
                    <select-box id="active"
                                v-model="formFields.active"
                                :options="subscriberActiveOptions"
						><translate class="translate">Stav uživatele</translate>
                    </select-box>
                </div>
              <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset" :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
            </div>

          <div class="table_overflow">
            <table class="vypis" ref="table_with_action_line" v-show="dataLoaded">
              <thead>
              <tr>
                <th class="no_padding drag_drop"></th>
                <th class="no_padding checkbox"></th>
                <sorting-table-title
                    v-for="title in sortingTableTitles"
                    :key="title.id"
                    :column="title.column"
                    :sort="getActiveSort(title.column)"
                    @changeSorting="changeSorting"
                >{{ title.name }}
                </sorting-table-title>
                <th class="no_padding edit"></th>
              </tr>
              </thead>
              <tbody>
              <user-row
                  v-for="user in entities"
                  :user="user"
                  :key="user.id"
                  :selectedUsers="selectedEntities"
                  :show-operator="$_readActionAllowedAllOrOwnAndGlobal"
                  @input="select"
                  @updateUser="updateEntity"
                  @deleteUser="deleteEntity"
              ></user-row>
              </tbody>
            </table>
          </div>

            <list-action-line
                    :entities="filteredOtherEntities"
                    :selected-entities="filteredSelectedEntities"
                    :multiple-action-options="multipleActionOptions"
                    :offset="formFields.offset"
                    :limit="formFields.limit"
                    :total-count="totalCount"
                    @select-all="toggleSelectAll"
                    @run-multiple-action="runMultipleAction"
                    @limit="setLimit"
                    @offset="setOffset"
                    ref="action_line"
            ></list-action-line>
        </div>
    </div>
</template>

<script>
	import UserRow from "@/components/views/users/UserRow"
	import AddButton from "@/components/common/AddButton"
	import SortingTableTitle from "@/components/common/SortingTableTitle"
	import FilterCheckbox from "@/components/common/FilterCheckbox"
	import Popup from "@/components/common/Popup"

	import listActions from "@/components/mixins/list-actions"

	export default {
		name: "UserList",
		components: {
			Popup,
			FilterCheckbox,
			SortingTableTitle,
			AddButton,
			UserRow
		},
		mixins: [listActions],
		data() {
			return {
				moduleName: 'users',
				formFields: {
					active: 'all',
					role: [],
				},
			}
		},
		created(UserService) {
			this.entityService = UserService
			this.createdInit()
		},
		computed: {
			multipleActionOptions() {
        let options = [
          {value: 'choose', text: this.$gettext('Vyberte akci')},
          {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')}
        ];
        if(this.$_updateActionAllowed){
          options.push({value: 'activate', text: this.$gettext('Aktivovat')});
          options.push({value: 'deactivate', text: this.$gettext('Deaktivovat')});
        }
        if(this.$_deleteActionAllowed){
          options.push({value: 'delete', text: this.$gettext('Smazat')});
        }

        return options;
			},
			sortingTableTitlesOperator() {
				return [
					{id: 1, name: this.$gettext('Příjmení jméno'), column: 'sName'},
					{id: 2, name: this.$gettext('Role'), column: 'sRole'},
					{id: 3, name: this.$gettext('Vloženo'), column: 'sDateCreated'},
					{id: 4, name: this.$gettext('Upraveno'), column: 'sDateUpdated'},
				]
			},
			sortingTableTitlesOwner() {
				return [
					{id: 1, name: this.$gettext('Příjmení jméno'), column: 'sName'},
					{id: 2, name: this.$gettext('Role'), column: 'sRole'},
					{id: 3, name: this.$gettext('Operátor'), column: 'sOperatorName'},
					{id: 4, name: this.$gettext('Vloženo'), column: 'sDateCreated'},
					{id: 5, name: this.$gettext('Upraveno'), column: 'sDateUpdated'},
				]
			},
			sortingTableTitles() {
				if (this.$_readActionAllowedAllOrOwnAndGlobal) {
					return this.sortingTableTitlesOwner
				} else {
					return this.sortingTableTitlesOperator
				}
			},
      csvHeaders(){
        let headers = this.getCsvHeaderFromSortingTableTitle(this.sortingTableTitles)
        headers.role.callback = entity => {
          let roleName = ''
          if (entity.role === 'ROLE_OPERATOR') {
            roleName = this.$gettext('Operátor')
          }
          if (entity.role === 'ROLE_OWNER') {
            roleName = this.$gettext('Majitel')
          }
          return roleName
        };

        return headers;
      },
			loggedUserId() {
				return String(this.$store.getters.getLoggedUserId)
			},
			filteredSelectedEntities() {
				let filteredAndSelected = []
				this._.forEach(this.entities, function (filteredUser) {
					if (this._.includes(this.selectedEntities, String(filteredUser['id']))) {
						if (String(filteredUser['id']) !== this.loggedUserId) {
							filteredAndSelected.push(filteredUser['id'])
						}
					}
				}.bind(this))

				return filteredAndSelected
			},
			filteredOtherEntities() { // except logged in user
				let filteredOtherUsers = []
				this._.forEach(this.entities, function (filteredOtherUser) {
					if (String(filteredOtherUser['id']) !== this.loggedUserId) {
						filteredOtherUsers.push(String(filteredOtherUser['id']))
					}
				}.bind(this))

				return filteredOtherUsers
			}
		},
		methods: {
			loadAdditionalDefaults() {
				let anyChanges = false
				if (this.loadDefaultByKey('active')) {
					anyChanges = true
				}
				if (this.loadDefaultByKey('role')) {
					anyChanges = true
				}
				return anyChanges
			},
			saveFilterValues() {
				this.saveSearch(this.formFields.search)
				this.setUserSetting('active', this.formFields.active)
				this.setUserSetting('role', this.formFields.role)
			},
			toggleSelectAll(value) {
				let selected = []
				if (value) {
					this.entities.forEach(function (user) {
						if (String(user.id) !== this.loggedUserId) {
							selected.push(String(user.id))
						}
					}.bind(this))
				}
				this.selectedEntities = selected
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/users/UserList.vue